'use client';

/**
 * Problem/solution comparison. Hidden for now: it renders nothing, but stays
 * exported so the landing sections barrel keeps a stable shape.
 */
export function ProblemSolution(): null {
  return null;
}
